<div class="home-container">
  <div class="animated-background">
    <div class="shape shape-1"></div>
    <div class="shape shape-2"></div>
    <div class="shape shape-3"></div>
    <div class="shape shape-4"></div>
    <div class="shape shape-5"></div>
  </div>
  <div class="welcome-content">
    <img src="assets/images/logo.svg" alt="OECD.AI Logo" class="welcome-logo" />
    <h1 class="welcome-title">Welcome to the OECD.AI Portal</h1>
    <p class="welcome-subtitle">
      Contribute to the global knowledge base on artificial intelligence
    </p>
  </div>
</div>
